export function useDuracionInput() {

    function validarYFormatearDuracion(valor) {

        let v = String(valor || "").toLowerCase()

        v = v.replace(/[^0-9hm ]/g, "")

        const hCount = (v.match(/h/g) || []).length

        if (hCount > 1) {

            const first = v.indexOf("h")

            v =
                v.substring(0, first + 1) +
                v.substring(first + 1).replace(/h/g, "")

        }

        const mCount = (v.match(/m/g) || []).length

        if (mCount > 1) {

            const first = v.indexOf("m")

            v =
                v.substring(0, first + 1) +
                v.substring(first + 1).replace(/m/g, "")

        }

        v = v.replace(/h(\d)/g, "h $1")

        v = v.replace(/\s+/g, " ")

        return v.trim()

    }

    function bloquearDuracion(e) {

        const permitidos = [
            "Backspace",
            "Delete",
            "ArrowLeft",
            "ArrowRight",
            "Tab"
        ]

        if (permitidos.includes(e.key)) {
            return
        }

        const input = e.target

        const valor = input.value

        const key = e.key.toLowerCase()

        if (/^[0-9]$/.test(key)) {

            const partes = valor.split("h")

            if (!valor.includes("h")) {

                const horas =
                    partes[0].replace(/\D/g, "")

                if (horas.length >= 2) {
                    e.preventDefault()
                }

                return
            }

            const minutos =
                (partes[1] || "")
                    .replace(/\D/g, "")

            if (minutos.length >= 2) {
                e.preventDefault()
            }

            return

        }

        if (key === "h") {

            if (valor.includes("h")) {
                e.preventDefault()
            }

            return

        }

        if (key === "m") {

            if (
                valor.includes("m") ||
                !valor.includes("h")
            ) {
                e.preventDefault()
            }

            return

        }

        if (key === " ") {
            return
        }

        e.preventDefault()

    }

    function duracionValida(v) {

        return /^\d+h \d+m$/.test(v)

    }

    // 🔥 IMPORTANTE
    return {

        validarYFormatearDuracion,

        bloquearDuracion,

        duracionValida

    }

}